import React from 'react';

import '@common/react/scss/components/simpleLoader.scss';

const SimpleLoader: React.FC<{className?: string}> = ({ className = '' }) => {
	return <div className={`simple-loader ${className}`} />;
};

export default SimpleLoader;
